// @ts-ignore — package types come from emitted .d.ts at runtime.
import type { AuthSessionManagerType } from '@finder/user-login/lib/session-manager';

const ARRIVAL_BUDGET_MS = 5000;
const ARRIVAL_POLL_MS = 50;

export const readSessionManager = (): AuthSessionManagerType | null => {
  const accessor = window.finderSessionManager;

  if (typeof accessor !== 'function') {
    return null;
  }

  try {
    return accessor() || null;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[global-nav] published session manager unavailable:', error);

    return null;
  }
};

export const whenSessionManager = (listener: (manager: AuthSessionManagerType) => void): void => {
  const existing = readSessionManager();

  if (existing) {
    listener(existing);

    return;
  }

  let waited = 0;

  const poll = window.setInterval(() => {
    const manager = readSessionManager();
    waited += ARRIVAL_POLL_MS;

    if (!manager && waited < ARRIVAL_BUDGET_MS) {
      return;
    }

    window.clearInterval(poll);

    if (!manager) {
      // eslint-disable-next-line no-console
      console.warn('[global-nav] no session manager was published for this page');

      return;
    }

    listener(manager);
  }, ARRIVAL_POLL_MS);
};
